import { Link } from 'react-router-dom'
import type { PropsWithChildren } from 'react'

import Button from '../button'

const LayoutDashboard: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <>
            <div className="mx-5 flex h-[77px] items-center justify-between md:container md:mx-auto">
                <Link to="/">
                    <img
                        src="/images/logo.png"
                        alt="logo"
                        className="h-10 w-[166px]"
                    />
                </Link>
                <Link to="/">
                    <Button className="rounded-lg bg-purple-500 px-8 py-[14px] text-sm text-white">
                        New Order
                    </Button>
                </Link>
            </div>
            <div className="min-h-[calc(100vh-77px)] bg-[#F6F6FB] pt-6 md:pt-14">
                {children}
            </div>
        </>
    )
}
export default LayoutDashboard
